//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { Header as Bus } from "@/matrix/events";
import Filters from "./filters/Filters";
import Selections from "./filters/Selections";
export default {
  name: "MatrixHeaderCell",
  props: ["data", "index"],
  components: {
    matrixFilters: Filters,
    matrixSelections: Selections
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    ...mapGetters(["computed", "authorized"]),
    filter() {
      return !!this.data.filterable;
    },
    groupClass() {
      let groupClass = new Set();
      let group = this.data.columnGroup;
      let headers = this.computed.headers;
      let index;
      let total = this.computed.headers.reduce((_total, header) => {
        if (header.columnGroup == group) _total++;
        if (header === this.data) index = _total;
        return _total;
      }, -1);

      if (
        !headers[this.index - 1] ||
        group !== headers[this.index - 1].columnGroup
      )
        groupClass.add("first");
      if (
        !headers[this.index + 1] ||
        group !== headers[this.index + 1].columnGroup
      )
        groupClass.add("last");
      if (index === Math.floor(total / 2)) {
        groupClass.add("text");
        if (total / 2 !== Math.floor(total / 2)) groupClass.add("text--push");
      }

      return [...groupClass].join(" ");
    }
  },
  methods: {
    toggle(e) {
      if (this.filter && !this.authorized) {
        e.stopPropagation();
        this.active = !this.active;
        Bus.$emit("TOGGLED", this.$el);
      }
    }
  },
  created() {
    if (this.filter && !this.authorized) {
      Bus.$on("TOGGLED", el => {
        if (this.$el != el) this.active = false;
      });
    }
  }
};
